
import { stringifyUrl } from '@/utils/url';
import { stopJoggingTimer, joggingMove,transitionsImg} from './canvaAnimation'
export class ImagePlayer {
    constructor(totalImages, errCallback) {
        console.log('ImagePlayer totalImages', totalImages)
        this.totalImages = totalImages;
        this.imageQueue = [];
        this.currentIndex = 0;
        this.canvas = document.getElementById('videoImgCanvas'); // 替换为实际的canvas元素
        this.ctx = this.canvas.getContext('2d');
        // this.currentImage = this.totalImages[0]
        // 绘制并缓存第一张图片
        this.drawIndexImage(0)
        this.timer = null;
        this.errCallback = errCallback;
        this.cacheNextImagesMap={}
        this.preImage={}
    }
    initCallback(loadingCallback) {
        this.loadingCallback = loadingCallback
    }
    
    loadImage(url) {
        return new Promise((resolve, reject) => {
            let img = new Image();
            img.src = url;
            img.onload = () => resolve(img);
            img.onerror = (err) => {
                // debugger
                reject(err);
                console.log(err);
            };

        });
    }
    
    drawIndexImage(index) {
        let curImageUrl = this.totalImages[index].imgUrl;
        this.loadImage(curImageUrl).then((res) => {
            this.canvas.width = res.width;
            this.canvas.height = res.height;
            // this.drawImage(res,this.canvas.width,this.canvas.height)
            this.ctx.drawImage(res, -0.2*this.canvas.width, -0.1*this.canvas.height, this.canvas.width*1.2, this.canvas.height*1.2);
            this.cacheNextImagesMap[curImageUrl]=res
        }).finally(() => {
            this.loadingCallback && this.loadingCallback()
        })
    }
    upadateCanvasDom() {
        this.canvas = document.getElementById('videoImgCanvas'); // 替换为实际的canvas元素
        this.ctx = this.canvas.getContext('2d');
    }
    drawImageByUrl(curImageUrl) {
        this.loadImage(curImageUrl).then((res) => {
            this.canvas.width = res.width;
            this.canvas.height = res.height;
            // this.drawImage(res,this.canvas.width,this.canvas.height)
            this.ctx.drawImage(res, 0, -0.1*this.canvas.height, this.canvas.width*1.2, this.canvas.height*1.2);
            this.cacheNextImagesMap[curImageUrl]=res
        })
    }
    updateImgList(imgList) {
        this.totalImages = imgList
        this.imageQueue = [];
        this.currentIndex = 0;
    }
    getTotalImages() {
        return this.totalImages;
    }

        // 缓存下一张图片函数
    cacheNextImages(time) {
       this.loadImage
    }
        // 播放图片
    playImage(startPlayTime) {
        // 如果当前索引已经超出总图片数，直接返回
        if (this.currentIndex >= this.totalImages) {
            return;
        }
        // 获取当前图片
        let currentImage = this.imageQueue.shift();
        // 如果存在上一张图片
        if (this.currentImage) {
            // 创建切换图片的选项
            let options = {
                ctx: this.ctx,
                oldImg: this.currentImage,
                newImg: currentImage,
                // type: 'slideleft',
                // duration: 500,
                canvasDom: this.canvas
            }
            // 切换图片动画
            transitionsImg(options)
        } else {
            // 否则直接绘制当前图片
            this.ctx.drawImage(currentImage, 0, 0);
        }

        // let options={width:width,height:height,"duration":'2000',"easing":"quadraticOut","type":"SlideInUp"}
        // this.ctx.drawImage(currentImage, 0, 0);
        // 缓存当前图片
        this.currentImage = currentImage
        // let curImageItem = this.totalImages[this.currentIndex];
        // 计算持续时间
        // let curImageItem = this.totalImages[this.currentIndex];
        // let duration = startPlayTime ? curImageItem.endTime - startPlayTime : curImageItem.endTime - curImageItem.startTime;
        // URL.revokeObjectURL(currentImage.src);

        // 更新当前索引
        this.currentIndex++;
        // 如果还有下一张图片，则缓存下一张图片
        if (this.currentIndex < this.totalImages.length) {
            this.cacheNextImages();
        }
    }
    init(options, currentImage) {
        console.log(canvaAnimate.animate);
        canvaAnimate.animate(this.canvas, currentImage, options)
    }
    getCurrentIndex(time) {
        let currentIndex = this.totalImages.findIndex((ele) => {
            return ele.startTime >= time || ele.endTime > time
        })
        if(currentIndex>=this.totalImages.length){
            return this.totalImages.length-1
        }
        this.currentIndex = currentIndex
    }
 
    drawImageByTime(time) {
        this.getCurrentIndex(time)
        let imgItem = this.totalImages[this.currentIndex]
        let direction = imgItem.direction
        let startOffset = this.getStartOffset(time,imgItem)
        let currentImage = this.cacheNextImagesMap[imgItem.imgUrl]
        if(!currentImage){
            this.loadImage(imgItem.imgUrl).then((res) => {
                this.cacheNextImagesMap[imgItem.imgUrl]=res
                this.drawImageOffset(res,startOffset,direction)
            })
        }else{
            this.drawImageOffset(currentImage,startOffset,direction)
        }
    }
    drawImageOffset(img,offset,direction) {
        let canvasDom = this.canvas
        this.ctx.clearRect(0, 0, canvasDom.width*1.2, canvasDom.height*1.2);
        if(direction =='left'||direction =='right'){
            // console.log('joggingMove',offset)
            this.ctx.drawImage(img, - offset, -canvasDom.height*0.1, canvasDom.width*1.2, canvasDom.height*1.2);
        }else{
            this.ctx.drawImage(img, -canvasDom.width*0.1, -offset,canvasDom.width*1.2, canvasDom.height*1.2);
        }
    }
    getStartOffset(time,imgItem) {
            let startOffset =0
            const slideWidth = this.canvas.width*0.2; // 推动的宽度
            const slideHeight = this.canvas.height*0.2; // 推动的宽度
            let time2 = parseInt((time-imgItem.startTime)*50)*20;
            let durationTime = (imgItem.endTime-imgItem.startTime)*1000;
            let direction = imgItem.direction
            if(direction ==='left'){
                startOffset =  (slideWidth/durationTime * time2);
            }else if(direction === 'up'){
                startOffset =  (slideHeight/durationTime * time2);
            }else if(direction == 'right'){
                startOffset = (slideWidth - (slideWidth/durationTime * time2));
            }else if(direction == 'down'){
                startOffset = (slideHeight - (slideHeight/durationTime * time2));
            }
            // console.log('startOffset',startOffset);
            if(startOffset <= 0){
                 startOffset=0
            }else if((direction==='up'||direction==='down')&&startOffset >= slideHeight){
                startOffset=slideHeight
            }else if((direction==='left'||direction==='right')&&startOffset >= slideWidth){
                startOffset=slideWidth
            }
            return startOffset
           
        
    }
    isCached =false
    drawImageByPlay(time) {
        console.log(time)
        this.getCurrentIndex(time)
        let imgItem = this.totalImages[this.currentIndex]
        if(!imgItem){return}
        // 播放过程中绘制图片，识别图片切换进行操作
        if ( this.preImage.imgUrl!=imgItem.imgUrl) {
            // this.drawImageByUrl(ImageItem.imgUrl)
            let currentImage = this.cacheNextImagesMap[imgItem.imgUrl]
            if(!currentImage){
                // 没有缓存，进行缓存；目前没遇到进入该判断的情况
                this.loadImage(imgItem.imgUrl).then((res) => {
                    this.cacheNextImagesMap[imgItem.imgUrl]=res
                    let options = {
                        ctx: this.ctx,
                        newImg: res,
                        direction:imgItem.direction||'right',
                        duration: (imgItem.endTime-imgItem.startTime)*1000,
                        canvasDom: this.canvas
                    }
                    let startOffset=this.getStartOffset(time,imgItem)
                    options.startOffset = startOffset
                    joggingMove(options)
                })
            }else{
                // 有上一张图片时，通过上一张图片转场数据做转换操作，然后微动
                let preItem = this.totalImages[this.currentIndex-1]
                if( preItem&&this.preImage.imgUrl){
                    let preImage = this.cacheNextImagesMap[preItem.imgUrl]
                    imgItem.duration = (imgItem.endTime-imgItem.startTime)*1000
                    let options = {
                        ctx: this.ctx,
                        oldImg: preImage,
                        oldImgItem:preItem,
                        newImgItem:imgItem,
                        duration: (imgItem.endTime-imgItem.startTime)*1000,
                        newImg: currentImage,
                        type: preItem.slideType,
                        direction:imgItem.direction,
                        canvasDom: this.canvas
                    }
                    transitionsImg(options)
                }else{
                    // 第一张图片，直接开始微动
                    let options = {
                        ctx: this.ctx,
                        newImg: currentImage,
                        direction:imgItem.direction||'right',
                        duration: (imgItem.endTime-imgItem.startTime)*1000,
                        canvasDom: this.canvas
                    }
                    let startOffset=this.getStartOffset(time,imgItem)
                    options.startOffset = startOffset
                    
                    // console.log('options',options);
                    joggingMove(options)
                }
            
            }
            this.preImage = imgItem
            //缓存下一张图片
            let cacheList=[]
            if(this.isCached){
                return
            }
            for(let i =this.currentIndex;i<=this.currentIndex+3;i++){
                if(i>=this.totalImages.length){
                    return
                }
                let cacheItem =  this.totalImages[i]
                if(!this.cacheNextImagesMap[cacheItem.imgUrl]){
                    this.isCached = true
                    this.loadImage(cacheItem.imgUrl).then((res) => {
                        this.isCached = false
                        this.cacheNextImagesMap[cacheItem.imgUrl]=res
                        console.log('cacheImages',cacheItem.imgUrl);
                    })
                }
            }
        }
      
    }

    play(time = 0) {
        return new Promise((r,j)=>{
            this.imageQueue = []
            this.getCurrentIndex(time)
            this.cacheNextImages().then(() => {
                // this.startCallback()
                // this.playImage();
                r(true)
            }).catch((res) => {
                console.log(res);
                reject("请求失败")
                j(res)
            });
    
        })
       
    }
    start(){
        this.preImage = {}
    }
    pause() {
        clearTimeout(this.timer)
        this.timer = null
        stopJoggingTimer()
        this.preImage = {}
    }
}
export class audioPlayer {
    constructor({ audioUrl, on = {} }) {
        this.audio = new Audio();
        this.audio.src = stringifyUrl({
            url: audioUrl,
            query: {
                _t: Date.now() // 避免音频走本地缓存，缓存偶现播放不出来
            }
        });
        this.audio.loop = false;
        this.audio.preload = 'metadata'

        this._on = on || {}
        this.addEvents()
    }
    get currentTime() {
        return this.audio.currentTime
    }
    get duration() {
        return this.audio.duration
    }
    get paused() {
        return this.audio.paused
    }
    play(time = 0) {
        // this.audio 从 第time秒进行播放
        this.audio.currentTime = time;
        this.audio.play();
    }
    pause() {
        this.audio.pause()
    }
    updateAudioUrl(audioUrl){
        this.audio.src = audioUrl
    }
    addEvents() {
        Object.keys(this._on).forEach(key => {
            this.audio.addEventListener(key, this._on[key])
        })
    }
    removeEvents() {
        Object.keys(this._on).forEach(key => {
            this.audio.removeEventListener(key, this._on[key])
        })
    }
    destroy() {
        this.removeEvents()
    }
}
//定义背景音播放类
export class backgroundAudioPlayer {
    constructor({ audioUrl, endCallback, audioDuration }) {
        this.audioUrl = audioUrl;
        this.initAudioContext();
        this.volume = 0.1;
        this.duration = audioDuration;
        this.endCallback = endCallback;
        //添加播放暂停和续播状态
        this.paused = true;
    }
    async initAudioContext() {
        if(!this.audioUrl) {
            // 删除背景音时，清除audioBuffer
            this.audioBuffer = null;
            return;
        }
        const audioContext = new (window.AudioContext || window.webkitAudioContext())();
        const res = await fetch(this.audioUrl);
        const arrayBuffer = await res.arrayBuffer(); 
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer, function (
          decodeData
        ) {
          return decodeData;
        });
        this.audioContext = audioContext;
        this.audioBuffer = audioBuffer;
    }
    play(time = 0, isCountinue = false) {
        this.audioSource?.stop();
        const audioContext = this.audioContext;
        const audioBuffer = this.audioBuffer;
        if(!audioContext || !audioBuffer) return;
        this.paused = false;
        const sourceNode = audioContext.createBufferSource(); // 创建音频源头节点
        sourceNode.buffer = audioBuffer; // 设置数据
        sourceNode.loop = true; //设置，循环播放

        const gainNode = audioContext.createGain();
        sourceNode.connect(gainNode);
        gainNode.connect(audioContext.destination); // 头尾相连
        gainNode.gain.value = this.volume; //设置音量

        this.audioSource = sourceNode;
        
        if (isCountinue) {
            sourceNode.start();
            return
        }
        let startTime = time % this.duration;
        sourceNode.start(0, startTime);
    }
    pause() {
        this.audioSource?.stop();
        this.paused = true;
    }
    end() {
        //停止播放
        this.audioSource?.stop();
        this.paused = true;

    }
    updateAudioUrl(audioInfo){
        this.audioUrl = audioInfo.audioUrl;
        this.initAudioContext();
        this.duration = audioInfo.duration
    }
    changeVolume(val) {
        this.volume = val;
    }
}
export class captionsPlayer {
    constructor({ captionsList, captionsCallback }) {
        this.captionsList = captionsList;
        this.captionsCallback = captionsCallback;
        this.currentIndex = 0;
        this.timer = null;
    }
    getCurrentIndex(time) {
        let currentIndex = this.captionsList.findIndex((ele) => {
            return ele.startTime >= time || ele.endTime > time
        })
        return currentIndex
    }
    play(curTime = 0) {
        if (curTime) {
            this.currentIndex = this.getCurrentIndex(curTime);
        }
        if (this.currentIndex === -1) {
            return
        }
        let captions = this.captionsList[this.currentIndex];
        this.captionsCallback(captions)
    }
    updateCaptionsList(textList) {
        this.captionsList= textList
    }
    getCaptionsList() {
        return this.captionsList
    }
    pause() {
        clearTimeout(this.timer)
        this.timer = null
    }
}

